module.exports = __webpack_public_path__ + "img/Scenarios_Cooperative_Growth.645a0f55.jpg";